import { useFormikContext } from "formik";

import { useFormData } from "../../../contexts/FormData";

import { Grid, Divider } from "@mui/material";

import { useQuery } from "@tanstack/react-query";

import { getInventoryValues } from "../../InventoryValues/apiService";

import Field from "../../../utils/FormikFields/Field";

import AutoCompleteSolo from "../../../utils/FormikFields/AutoCompleteSolo";

import { InputLabel } from "../../../utils/Common";

const getOptions = (values) => {
  return values?.map((el) => ({
    label: el.value,
    value: el.value,
  }));
}

const Values = () => {
  const { values } = useFormikContext() || {};

  const { formValues, setFormValues } = useFormData() || {};

  const { data: valuesList } = useQuery({
    queryKey: ["values", values?.brand_name],
    queryFn: () => getInventoryValues(values?.brand_name),
    enabled: !!values?.brand_name,
    // staleTime: Infinity,
  });

  let colors = valuesList?.filter(el => el.attribute === "color");
  let sizes = valuesList?.filter(el => el.attribute === "size");
  let materials = valuesList?.filter(el => el.attribute === "material");
  let hairstyles = valuesList?.filter(el => el.attribute === "hairstyle");
  let lines = valuesList?.filter(el => el.attribute === "line");
  let lengths = valuesList?.filter(el => el.attribute === "length");

  let disabled = Boolean(!values?.brand_name || !!formValues?.inventory_item)
  return (
    <>
      <Grid size={{xs: 12, lg: 4}}>
        <InputLabel>Color</InputLabel>
        <AutoCompleteSolo 
          name="color" 
          fieldName="value"
          label="Color" 
          serverOptions={colors} 
          disabled={disabled}
          simple={true} 
        />
      </Grid>
      <Grid size={{xs: 12, lg: 2}}>
        {/* <Field name="length" label="Length" formFieldType="select" options={getOptions(lengths)} disabled={disabled} /> */}
        <InputLabel>Length</InputLabel>
        <AutoCompleteSolo 
          name="length" 
          fieldName="value"
          label="Length" 
          serverOptions={lengths} 
          disabled={disabled}
          simple={true} 
          type="number"
        />
      </Grid>
      <Grid size={{xs: 12, lg: 2}}>
        {/* <Field name="length" label="Length" formFieldType="select" options={getOptions(lengths)} disabled={disabled} /> */}
        <Field formFieldType="select" name="length_unit" label="Length Unit" disabled={disabled} options={[{value: "in", label: "Inches"}, {value: "cm", label: "CM"}]} InputProps={{sx: {bgcolor: "#fff"}}} />
      </Grid>
      <Grid size={{xs: 12, lg: 4}}>
        {/* <Field name="cap_size" label="Size" formFieldType="select" options={getOptions(sizes)} disabled={disabled} /> */}
        <InputLabel>Size</InputLabel>
        <AutoCompleteSolo 
          name="cap_size" 
          fieldName="value"
          label="Size" 
          serverOptions={sizes} 
          disabled={disabled}
          simple={true} 
        />
      </Grid>
      <Grid size={{xs: 12, lg: 4}}>
        {/* <Field name="material" label="Wig Type" formFieldType="select" options={getOptions(materials)} disabled={disabled} /> */}
        <InputLabel>Wig Type</InputLabel>
        <AutoCompleteSolo 
          name="material" 
          fieldName="value"
          label="Wig Type" 
          serverOptions={materials} 
          disabled={disabled}
          simple={true} 
        />
      </Grid>
      <Grid size={{xs: 12, lg: 4}}>
        {/* <Field name="hairstyle" label="Hairstyle" formFieldType="select" options={getOptions(hairstyles)} disabled={disabled} /> */}
        <InputLabel>Hairstyle</InputLabel>
        <AutoCompleteSolo 
          name="hairstyle" 
          fieldName="value"
          label="Hairstyle" 
          serverOptions={hairstyles} 
          disabled={disabled}
          simple={true} 
        />
      </Grid>
      <Grid size={{xs: 12, lg: 4}}>
        {/* <Field name="line" label="Collection" formFieldType="select" options={getOptions(lines)} disabled={disabled} /> */}
        <InputLabel>Collection</InputLabel>
        <AutoCompleteSolo 
          name="line" 
          fieldName="value"
          label="Collection" 
          serverOptions={lines} 
          disabled={disabled}
          simple={true} 
        />
      </Grid>
      <Grid size={{xs: 12, lg: 4}}>
        <Field name="has_highlights" label="Has Highlights" formFieldType="switch" type="checkbox" disabled={disabled} />
      </Grid>
    </>
  )
};

export default Values;